import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Alex Efremo
 * id 6B34986A-5D17-4C64-9840-994B66EC00AB
 * name garage-open
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/garage-open.svg
 * tags
 * - Home Automation 
 */
export const GarageOpenIcon = createSvgIcon(<><path d="M19,20H17V11H7V20H5V9L12,5L19,9V20M8,12H16V14H8V12Z" /></>, 'GarageOpenIcon');
export default GarageOpenIcon